import ReportHistoryPage from "report/report-history-page/ReportHistoryPage";
import ReportRenderPage from "report/report-render-page/ReportRenderPage";
import ReportsPage from "report/reports-page/ReportsPage";
import isDashboardPageUsedInReports from "report/logic/IsDashboardPageUsedInReports";
import isDashboardUsedInReports from "report/logic/IsDashboardUsedInReports";
import isWidgetUsedInReports from "report/logic/IsWidgetUsedInReports";
import ReportingConfig from "report/ReportingConfig";
import CreateReportPage from "report/report-creation/CreateReportPage";
import ReportRoutes from "report/ReportRoutes";
import EditReportPage from "report/report-creation/EditReportPage";
import reportEntityPermissionsMapper from "report/ReportEntityPermissionsMapper";
import * as ReportPermissions from "report/ReportPermissions";
const bindings = {
  routes: [
    { path: ReportRoutes.unqualified.OVERVIEW, component: ReportsPage, permissions: "inputs:create" },
    {
      path: `${ReportRoutes.unqualified.NEW}/*`,
      component: CreateReportPage,
      permissions: "inputs:create"
    },
    {
      path: `${ReportRoutes.unqualified.contents()}/*`,
      component: EditReportPage,
      permissions: "inputs:create"
    },
    { path: ReportRoutes.unqualified.archive(), component: ReportHistoryPage, permissions: "inputs:create" },
    {
      path: ReportRoutes.unqualified.render(),
      component: ReportRenderPage,
      permissions: "inputs:create",
      parentComponent: null
    }
  ],
  "views.hooks.confirmDeletingDashboard": [isDashboardUsedInReports],
  "views.hooks.confirmDeletingDashboardPage": [isDashboardPageUsedInReports],
  "views.hooks.confirmDeletingWidget": [isWidgetUsedInReports],
  systemConfigurations: [
    {
      component: ReportingConfig,
      displayName: "Reporting",
      configType: "org.graylog.plugins.report.configuration.ReportingSystemConfiguration",
      readPermission: "report_configuration:read"
    }
  ],
  entityPermissionsMapper: reportEntityPermissionsMapper,
  entityCreators: [
    {
      id: "Report",
      title: "Create report",
      path: ReportRoutes.NEW,
      permissions: ReportPermissions.create
    }
  ],
  entityTypeRoute: [
    {
      type: "report",
      route: (id) => ReportRoutes.archive(id)
    }
  ]
};
export default bindings;
